// extracted by mini-css-extract-plugin
export default {"item":"Item_item__LMTVm","active":"Item_active__irzt4","head":"Item_head__-edQf","body":"Item_body__eW9Co","category":"Item_category__dD5QT"};